



























































































import { Component, Vue } from 'vue-property-decorator';
import { IContractUpdate } from '@/interfaces';
import { dispatchGetContracts, dispatchUpdateContract } from '@/store/contract/actions';
import { readAdminOneContract } from '@/store/contract/getters';

@Component
export default class EditContract extends Vue {
  public valid = true;
  public clientEmail: string = '';
  public contractComment: string = '';
  public mac: string = '';
  public key1: string = '';
  public enable_last_seen_report: boolean | undefined = false;
  public comma_separated_emails: string | undefined = ''
  public watchers: string[] | undefined  = [];

  public async mounted() {
    await dispatchGetContracts(this.$store);
    this.reset();
  }

  public reset() {
    this.$validator.reset();
    if (this.contract) {
      this.key1 = this.contract.key1;
      this.clientEmail = this.contract.client_email;
      this.contractComment = this.contract.comment;
      this.mac = this.contract.mac;
      this.enable_last_seen_report = this.contract.enable_last_seen_report ?  this.contract.enable_last_seen_report : undefined
      this.watchers = this.contract.watchers ? this.contract.watchers : undefined
      this.comma_separated_emails = this.contract.watchers ? this.contract.watchers.join() : ''
    }
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    if (await this.$validator.validateAll()) {
      const updatedContract: IContractUpdate = {};
      if (this.clientEmail) {
        updatedContract.client_email = this.clientEmail;
      }
      if (this.contractComment) {
        updatedContract.comment = this.contractComment;
      }
      if (this.mac) {
        updatedContract.mac = this.mac;
      }

      if (this.watchers && this.watchers.length > 0){
        updatedContract.watchers = this.watchers
      }
      // take the status of enable_last_seen_report
      updatedContract.enable_last_seen_report = this.enable_last_seen_report
      
      await dispatchUpdateContract(this.$store, { key1: this.contract!.key1, contract: updatedContract });
      this.$router.push('/main/contracts');
    }
  }

  get contract() {
    return readAdminOneContract(this.$store)(this.$router.currentRoute.params.key1);
  }

  get enable_report_label() {
    if (this.enable_last_seen_report) {
      return "Disable last seen report (currently enabled)"
    }
    else {
      return "Enable last seen report (currently disabled)" 
    }
  }

  generate_email_list() {
    if(this.comma_separated_emails){
      this.watchers = []
      if(this.comma_separated_emails.includes(",") || this.validateEmail(this.comma_separated_emails)){
        let separated_array = this.comma_separated_emails.split(',')
        for (let x in separated_array){
          if(this.validateEmail(separated_array[x].trim())) {
            this.watchers.push(separated_array[x].trim())
          }
        }       
      }     
    }
  }

  remove_email(email) {
    if(this.watchers){
      this.watchers = this.watchers.filter(function(e) { return e !== email })
      this.comma_separated_emails = this.watchers.join()
    }
  }

  validateEmail(email) {
    const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return pattern.test(email);
  }
}
